<template>
    <div class="faq-container">
        <h1 class="faq-container__title strong">
            {{ title }}
        </h1>
        <item
            v-for="faq in faqs"
            :key="faq.id"
            class="faq-container__items"
            :item="faq"
        />
    </div>
</template>

<script>
import FaqData from '@/assets/data/faq.json';
import Item from './partials/Item';

export default {
    name: 'Faq',
    components: { Item },
    props: { title: { type: String, default: 'F.A.Q' } },
    data() {
        return {
            loading: false,
            faqs: FaqData,
        };
    },
};
</script>

<style scoped lang="scss">
.faq-container {
    color: #727272;
    display: flex;
    flex-direction: column;
    margin-bottom: 10rem;
    &__title {
        text-align: center;
        justify-self: center;
        height: 52px;
        color: #0a294a;
        font-family: $politica-font;
        font-size: 38px;
        font-weight: 800;
        letter-spacing: 0.98px;
        line-height: 51px;
        text-transform: uppercase;
        padding-bottom: 10rem;
    }
    &__items {
        margin: 0 auto 0 3rem;
    }
}
</style>
